// Constants
import { LDFlagSet } from "launchdarkly-react-client-sdk";
import {
    COMMISSIONS_DETAILED_VIEW,
    COMMISSIONS_SUMMARY_VIEW,
    EU_SPECIFIC_LEGAL_ENTITY,
    FIRPTA_CATEGORY
} from "../Constants/Constants";

export const getRoleAccessFunction = (affiliateDetails: any, launchDarklyFlags: LDFlagSet, isSuperUser: boolean = false) => {
    const { affiliate = {} } = affiliateDetails || {};
    const { category, isPrimary, commission_view, trading_name, legal_entity } = affiliate;

    const showCommissions: boolean =
        commission_view === COMMISSIONS_SUMMARY_VIEW || commission_view === COMMISSIONS_DETAILED_VIEW;

    let defaultAccess = {
        VIEW_ACCOUNT: true,
        VIEW_BANK_DETAILS: true,
        VIEW_CLIENT_MANAGEMENT: false,
        REGISTER_CLIENT: false,
        VIEW_INVOICES: true,
        VIEW_COMMISSION: showCommissions,
        REFER_CLIENT: !isSuperUser,
        VIEW_REFERRALS: true,
        VIEW_NOTIFICATIONS: !isSuperUser,
        VIEW_RESOURCES: true && handleResources(trading_name, launchDarklyFlags),
        VIEW_SETTINGS: true,
        SEND_REGISTRATION_LINK: !isSuperUser,
        BANK_DOCUMENT_UPLOAD: false
    };

    if (category === FIRPTA_CATEGORY && !isSuperUser) {
        defaultAccess = {
            ...defaultAccess,
            VIEW_CLIENT_MANAGEMENT: true,
            REGISTER_CLIENT: true,
            VIEW_INVOICES: isPrimary,
            VIEW_COMMISSION: isPrimary,
            VIEW_REFERRALS: isPrimary,
            VIEW_NOTIFICATIONS: isPrimary,
            VIEW_SETTINGS: isPrimary,
            VIEW_ACCOUNT: isPrimary,
            VIEW_BANK_DETAILS: isPrimary
        };
    }

    if (EU_SPECIFIC_LEGAL_ENTITY.includes(legal_entity)) {
        defaultAccess = {
            ...defaultAccess,
            BANK_DOCUMENT_UPLOAD: true
        };
    }

    return defaultAccess;
};


export const handleResources = (tradingName: string, launchDarklyFlags: LDFlagSet): boolean => {
    const disableResourcePageModule: string[] = launchDarklyFlags?.disableResourcePageModule;

    if (!disableResourcePageModule) return true;

    const normalizedTradingName: string = tradingName?.toLowerCase() ?? '';
    return !disableResourcePageModule.some(item =>
        item.toLowerCase() === normalizedTradingName
    );
}
